"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NightIcon = void 0;
const react_1 = __importDefault(require("react"));
const NightIcon = () => (react_1.default.createElement("svg", { viewBox: "0 0 16 16" },
    react_1.default.createElement("path", { fill: "none", d: "M0 0h16v16H0z" }),
    react_1.default.createElement("path", { d: "M8.001 8a6.496 6.496 0 014.998-6.318A6.955 6.955 0 0010.001 1a7 7 0 100 14 6.955 6.955 0 002.998-.682A6.497 6.497 0 018.001 8z", fill: "#4997c7" })));
exports.NightIcon = NightIcon;
//# sourceMappingURL=NightIcon.js.map